import { global } from '@/global';
import Cookies from 'js-cookie';

export default {
	state: {
		chatStatus: Cookies.get(global['CHAT_STATUS']) || "close",
		chatNickname: Cookies.get(global['CHAT_NICKNAME']) || null,
		chatMail: Cookies.get(global['CHAT_MAIL']) || null,
		chatPhone: Cookies.get(global['CHAT_PHONE']) || null,
		chatMessages: Cookies.get(global['CHAT_MESSAGES']) || null,
		chatSecureKey: Cookies.get(global['CHAT_SECUREKEY']) || null,
		chatAgent: Cookies.get(global['CHAT_AGENT']) || null,
	},
	getters: {
		getChatStatus: state => state.chatStatus,
		getChatNickname: state => state.chatNickname,
		getChatMail: state => state.chatMail,
		getChatPhone: state => state.chatPhone,
		getChatMessages: state => state.chatMessages,
		getChatSecureKey: state => state.chatSecureKey,
		getChatAgent: state => state.chatAgent,
	},
	mutations: {
		setChatStatus: (state, status) => state.chatStatus = status,
		setChatNickname: (state, nickname) => state.chatNickname = nickname,
		setChatMail: (state, mail) => state.chatMail = mail,
		setChatPhone: (state, phone) => state.chatPhone = phone,
		setChatMessages: (state, messages) => state.chatMessages = messages,
		setChatSecureKey: (state, key) => state.chatSecureKey = key,
		setChatAgent: (state, agent) => state.chatAgent = agent,
		removeChatStatus: (state) => state.chatStatus = "close",
		removeChatNickname: (state) => state.chatNickname = null,
		removeChatMail: (state) => state.chatMail = null,
		removeChatPhone: (state) => state.chatPhone = null,
		removeChatMessages: (state) => state.chatMessages = null,
		removeChatSecureKey: (state) => state.chatSecureKey = null,
		removeChatAgent: (state) => state.chatAgent = null,
	},
	actions: {
		setChatStatus({ commit }, status) {

			Cookies.set(global["CHAT_STATUS"], status, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatStatus', status);
		},
		setChatNickname({ commit }, nickname) {

			Cookies.set(global["CHAT_NICKNAME"], nickname, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatNickname', nickname);
		},
		setChatMail({ commit }, mail) {

			Cookies.set(global["CHAT_MAIL"], mail, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatMail', mail);
		},
		setChatPhone({ commit }, phone) {

			Cookies.set(global["CHAT_PHONE"], phone, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatPhone', phone);
		},
		setChatMessages({ commit }, messages) {

			Cookies.set(global["CHAT_MESSAGES"], messages, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatMessages', messages);
		},
		setChatSecureKey({ commit }, key) {

			Cookies.set(global["CHAT_SECUREKEY"], key, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatSecureKey', key);
		},
		setChatAgent({ commit }, agent) {

			Cookies.set(global["CHAT_AGENT"], agent, {
				expires: global["TOKEN_EXPIRES"]
			});

			commit('setChatAgent', agent);
		},
		async deletechat({ commit }) {
			return new Promise((resolve) => {
				Cookies.remove(global['CHAT_STATUS']);
				Cookies.remove(global['CHAT_NICKNAME']);
				Cookies.remove(global['CHAT_MAIL']);
				Cookies.remove(global['CHAT_PHONE']);
				Cookies.remove(global['CHAT_MESSAGES']);
				Cookies.remove(global['CHAT_SECUREKEY']);
				Cookies.remove(global['CHAT_AGENT']);
				commit('removeChatStatus');
				commit('removeChatNickname');
				commit('removeChatMail');
				commit('removeChatPhone');
				commit('removeChatMessages');
				commit('removeChatSecureKey');
				commit('removeChatAgent');
				resolve(true)
			})
		}
	}
}